import React from 'react';

type Rector = {
  id: number;
  name: string;
  slug: string;
  startYear: number;
  endYear: number | null;
  image: string | null;
  bio: string | null;
};

export const RectorTimeline: React.FC<{ rectors: Rector[] }> = ({ rectors }) => {
  if (rectors.length === 0) return null;

  return (
    <div className="rector-timeline">
      {rectors.map((r, idx) => {
        const isCurrent = r.endYear === null;
        return (
          <div key={r.id} className={`rector-timeline__item ${idx % 2 === 0 ? 'left' : 'right'}`}>
            <div className="rector-timeline__dot" />
            <div className="rector-timeline__card">
              {r.image && (
                <img src={r.image} alt={r.name} className="rector-timeline__img" />
              )}
              <div className="rector-timeline__body">
                <div className="rector-timeline__years">
                  <span className="rector-timeline__year">{r.startYear}</span>
                  <span className="rector-timeline__sep">—</span>
                  <span className="rector-timeline__year">{isCurrent ? 'Présent' : r.endYear}</span>
                  {isCurrent && <span className="rector-timeline__badge">Actuel</span>}
                </div>
                <h3 className="rector-timeline__name">{r.name}</h3>
                <p className="rector-timeline__bio">{r.bio}</p>
              </div>
            </div>
          </div>
        );
      })}
    </div>
  );
};
